import React, {useEffect} from 'react';
import {BrowserRouter as Router} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {dispatchLogin, fetchUser, dispatchGetUser} from './redux/actions/authAction'

import Header from './components/header/Header'
import Body from './components/body/Body'
import axios from 'axios';
import {  Route, Switch, Redirect } from "react-router-dom";

import Admin from "layouts/Admin.js";
import RTL from "layouts/RTL.js";
import AuthLayout from "layouts/Auth.js";

import { PrivateRoute } from './PrivateRoute';

//import "assets/css/material-dashboard-react.css?v=1.9.0";

function App() {
  


  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/admin" component={Admin} />
          <Route path="/auth" component={AuthLayout} />
          <Redirect from="/" to="/auth/login-page" />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
